import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";

export default function BillingPaymentMethodsTab() {
  const hasPaymentMethod = false;

  return (
    <Box sx={{ p: 2, display: "grid", gap: 2 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Payment Methods
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Connect a payment method to pay for your Elite Core subscription.
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ p: 2, display: "grid", gap: 1.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Stripe Connection
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.75 }}>
          {hasPaymentMethod
            ? "Your payment method is connected and ready for renewals."
            : "No payment method connected yet. Add a card via Stripe to keep your subscription active."}
        </Typography>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Button variant="contained" color="primary">
            Connect Stripe Payment Method
          </Button>
          <Button variant="outlined" color="primary" disabled={!hasPaymentMethod}>
            Pay Now
          </Button>
        </Box>
        <Typography variant="caption" sx={{ opacity: 0.6 }}>
          Stripe checkout and customer portal wiring is coming soon.
        </Typography>
      </Paper>
    </Box>
  );
}
